import React from "react";

import Stack from "react-bootstrap/Stack";
import { useTranslation } from "react-i18next";

import "./PendingGamesInfoModal.scss";
import BottomDrawer from "../../../BottomDrawer/BottomDrawer";
import AlertWarningIcon from "../../../icons/AlertWarningIcon";
import PrimaryActionButton from "../../../Buttons/PrimaryActionButton/PrimaryActionButton";

interface PendingGamesInfoModalProps {
  show?: boolean;
  onHide?: () => void;
}

function PendingGamesInfoModal(props: PendingGamesInfoModalProps) {
  const { onHide, show } = props;
  const { t } = useTranslation("common");
  const handleClose = () => onHide?.();

  return (
    <BottomDrawer
      isOpen={!!show}
      onClose={handleClose}
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Stack className="pending-games-info-modal">
        <div className="icon-wrapper">
          <AlertWarningIcon width={64} height={64} />
        </div>
        <h2 id="contained-modal-title-vcenter" className="text-center">
          {t("pending_game")}
        </h2>{" "}
        <p className="explainer text-center">
          {t("there_is_no_score_for_this_game_key")}
        </p>
        <PrimaryActionButton onClick={handleClose} text={t("got_it")} />
      </Stack>
    </BottomDrawer>
  );
}

export default PendingGamesInfoModal;
